<template>
  <div class="position-absolute w-100 z-20 overflow-hidden pointer-events-none page-footer-wrap" :style="wrapStyles">
    <div class="position-relative inner-footer" :style="wrapStyles">
      <svg xmlns="http://www.w3.org/2000/svg" :viewBox="'0 0 ' + winW + ' ' + wrapH">
        <defs>
          <linearGradient
            id="page6foot-a"
            :x1="backGrad.x1 + '%'"
            :x2="backGrad.x2 + '%'"
            :y1="backGrad.y1 + '%'"
            :y2="backGrad.y2 + '%'"
          >
            <stop offset="0%" :stop-color="mainColor"/>
            <stop offset="100%" :stop-color="accent"/>
          </linearGradient>
          <linearGradient
            id="page6foot-b"
            :x1="frontGrad.x1 + '%'"
            :x2="frontGrad.x2 + '%'"
            :y1="frontGrad.y1 + '%'"
            :y2="frontGrad.y2 + '%'"
          >
            <stop offset="0%" :stop-color="mainColor"/>
            <stop offset="100%" :stop-color="accent"/>
          </linearGradient>
        </defs>

        <polygon
          fill="url(#page6foot-a)"
          :points="winW + ' ' + (wrapH + backOffsets.br) + ' 0 ' + (wrapH + backOffsets.bl) + ' 0 0 ' + winW + ' ' + backPt"
          ref="backGrad"
        />
        <polygon
          fill="url(#page6foot-b)"
          :points="'0 ' + (wrapH + frontOffsets.bl) + ' 0 ' + frontPtLow + ' ' + winW + ' ' + frontPtHigh + ' ' + winW + ' ' + (wrapH + frontOffsets.br)"
          ref="pageGrad"
        />
      </svg>

      <div
        class="position-absolute w-100 d-flex flex-column justify-content-center align-items-center user-select-none footer-text"
        :class="[ allowPointer ? 'pointer-events-auto' : '' ]"
        :style="{ height: h + 'px' }"
        @click="handleClick"
        @touchstart="touchstart"
        @touchmove.prevent="touchmove"
        @touchend="touchend"
        ref="footText"
      >
        <span ref="numeral" class="numeral" v-html="numeral + '.'"></span>
        <span ref="keyword" class="keyword" v-html="keyword"></span>
        <span ref="subhead" class="subhead" v-html="subhead"></span>
      </div>

      <div class="position-fixed w-100 h-100 pointer-events-none fade-to-white" style="opacity: 0" ref="fade"></div>

    </div>
  </div>

</template>

<script>
  import { TimelineMax, Power1 } from 'gsap'
  import FooterMixin from '@/components/report/mixins/FooterMixin'

  export default {
    name: 'Foot6',
    mixins: [ FooterMixin ],
    data () {
      return {
        tl: new TimelineMax(),
        backOffsets: {
          bl: 0, // -> 100
          br: 0 // -> 20
        },
        frontOffsets: {
          bl: 0, // -> 24
          br: 0  // -> 104
        },
        backGrad: {
          x1: 50,     // -> 12.794
          x2: 50,     // -> 31.221
          y1: 39.46,  // -> 98.029
          y2: 0       // -> 71.65
        },
        frontGrad: {
          x1: 106.197,  // -> 45.744
          x2: 39.732,   // -> 45.744
          y1: 63.513,   // -> 100
          y2: -3.441    // -> 9.216
        }
      }
    },
    methods: {
      setTweens () {
        this.tl.set( this.$refs.keyword, { yPercent: 50, rotationX: 30, rotationY: 30 } )
          .set( this.$refs.subhead, { yPercent: 100 } )
          .set( [ this.$refs.numeral, this.$refs.keyword, this.$refs.subhead ], { opacity: 0 } )
          .set( [ this.$refs.pageGrad, this.$refs.backGrad, this.$refs.footText ], { y: this.wrapH } )
      },

      tweenIn () {
        this.tl.staggerTo( [ this.$refs.pageGrad, this.$refs.backGrad, this.$refs.footText ], this.time, {
          y: this.wrapH - this.h,
          ease: Power1.easeInOut
        }, this.stagger / 2, 'in' )
          .to( this.$refs.numeral, this.time / 2, { opacity: 1 }, 'in+=' + (this.stagger * 3 + this.time * 0.5) )
          .to( this.$refs.keyword, this.time / 2, {
            opacity: 1,
            rotationX: 0,
            rotationY: 0,
            yPercent: 0
          }, 'in+=' + (this.stagger * 4 + this.time * 0.5) )
          .to( this.$refs.subhead, this.time / 2, {
            opacity: 1,
            yPercent: 0
          }, 'in+=' + (this.stagger * 5 + this.time * 0.5) )
      },

      tweenOut () {
        this.tl.to( this, this.time, { backPt: 0, frontPtLow: 0, frontPtHigh: 0, ease: Power1.easeInOut }, 'out' )
          .to( this.$refs.fade, this.time, { opacity: 1 }, 'out' )
          .to( this.backOffsets, this.time, { bl: 100, br: 20, ease: Power1.easeInOut }, 'out' )
          .to( this.frontOffsets, this.time, { bl: 24, br: 104, ease: Power1.easeInOut }, 'out' )
          .to( this.backGrad, this.time, { x1: 12.794, x2: 31.221, y1: 98.029, y2: 71.65, ease: Power1.easeInOut }, 'out' )
          .to( this.frontGrad, this.time, { x1: 45.744, x2: 45.744, y1: 100, y2: 9.216, ease: Power1.easeInOut }, 'out' )
          .to( [ this.$refs.backGrad, this.$refs.pageGrad ], this.time, { y: 0, ease: Power1.easeInOut }, 'out' )
          .to( this.$refs.footText, this.time / 2, { opacity: 0 }, 'out' )
          .to( this.$refs.keyword, this.time, { yPercent: 50, rotationX: 30, rotationY: 30 }, 'out' )
          .to( this.$refs.subhead, this.time, { yPercent: 100 }, 'out+=' + this.stagger )
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/the_goods";

  .fade-to-white {
    top        : 0;
    left       : 0;
    background : $white;
    z-index    : 15;
    transform  : none !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/report/footers/Foot6.vue